import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProprieteRoutingModule } from './propriete-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { ProprieteComponent } from './propriete.component';
import { ProprieteGuard } from './propriete-guard.service';
import { ListeProprietesComponent } from './containers/liste-proprietes/liste-proprietes.component';
import { FormulaireProprieteComponent } from './containers/formulaire-propriete/formulaire-propriete.component';
import { EditPhotoComponent } from './components/edit-photo/edit-photo.component';
import { MaterialModule } from '../material.module';
import { PageIntroductionComponent } from './components/page-introduction/page-introduction.component';
import { PropertyDetailsComponent } from './containers/property-details/property-details.component';
import { PropertyDetailsPaymentsComponent } from './components/property-details-payments/property-details-payments.component';
import { PropertyDetailsPhotoComponent } from './components/property-details-photo/property-details-photo.component';
import { PropertyDetailsIllustrationComponent } from './components/property-details-illustration/property-details-illustration.component';
import { PropertyDetailsFeesComponent } from './components/property-details-fees/property-details-fees.component';
import { PropertyDetailsOldInfoComponent } from './components/property-details-old-info/property-details-old-info.component';
import { FraisProprieteComponent } from './components/property-details-fees/frais-propriete/frais-propriete.component';
import { PropertyDetailsAddDepensesComponent } from './components/property-details-add-depenses/property-details-add-depenses.component';
import { InViewportModule } from 'ng-in-viewport';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { PropertySceneDesktopComponent } from './components/property-details-illustration/scenes/property-scene-desktop/property-scene-desktop.component';
import { PropertySceneMobileComponent } from './components/property-details-illustration/scenes/property-scene-mobile/property-scene-mobile.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [
    ProprieteComponent,
    ListeProprietesComponent,
    FormulaireProprieteComponent,
    EditPhotoComponent,
    PageIntroductionComponent,
    PropertyDetailsComponent,
    PropertyDetailsPaymentsComponent,
    PropertyDetailsPhotoComponent,
    PropertyDetailsIllustrationComponent,
    PropertyDetailsFeesComponent,
    PropertyDetailsOldInfoComponent,
    FraisProprieteComponent,
    PropertyDetailsAddDepensesComponent,
    PropertySceneDesktopComponent,
    PropertySceneMobileComponent
  ],
  exports: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ProprieteRoutingModule,
    CoreModule,
    SharedModule,
    MaterialModule,
    InViewportModule,
    NgxTippyModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [ProprieteGuard, provideHttpClient(withInterceptorsFromDi()), provideNgxMask()]
})
export class ProprieteModule {}
